import useAPI from '@/hooks/useAPI';
import SubstanceRepository from '@/repositories/SubstanceRepository';
import { QueryParams } from '@/types/query';

export const usePrimarySubstances = (params: QueryParams = {}, enabled = true) => {
  const substanceRepository = SubstanceRepository();

  return useAPI({
    queryKey: ['getPrimarySubstances', params],
    queryFn: async () => {
      return await substanceRepository.list(params);
    },
    enabled
  });
};

export default usePrimarySubstances;
